import {Organisation} from '../../interfaces/core/organisation';

export class OrganisationFactory {

  /**
   *
   * @param organisation
   */
  public static fromObject(organisation: any): Organisation {
    return new class implements Organisation {
      id: number = organisation.base_url;
      logo: string = organisation.logo;
      shortName: string = organisation.short_name;
      name: string = organisation.name;
      baseUrl: string = organisation.base_url;
      logoUrl: string = organisation.logo_url;
      isTestVersion: boolean = organisation.is_test_version;
      bgColor: string = organisation.bg_color;
      fontColor: string = organisation.font_color;
      keys: string[] = organisation.keys;
    };
  }

  /**
   *
   * @param organisations
   */
  public static fromArray(organisations: any[]): Organisation[] {
    return organisations.map(_organisation => OrganisationFactory.fromObject(_organisation));
  }

}
